// extracted by mini-css-extract-plugin
export var quantityInput = "_hu-0";